var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<dl ng-show=\"!vm.editing\" class=\"no-animate\"><dt>{{ vm.label }}</dt><dd ng-class=\"{'is-active': (vm.selecting == vm.name)}\" class=\"c-timeframe-date__label\">{{ (vm.ngModel||'-') | date:'short' }}</dd></dl><dl ng-show=\"vm.editing\" class=\"no-animate\"><dt>{{ vm.label }}</dt><dd><input type=\"text\" ng-model=\"vm.ngModel\" ng-change=\"vm.onChange()\" date-parser=\"{}\" class=\"c-timeframe-date__input\"/></dd></dl>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/datetime/timeframe-date.jade
 ** module id = 272
 ** module chunks = 0
 **/